import '../../asset/style/style.scss';
import './application.scss';
import refreshIcon from '../../asset/images/refresh_blue.svg';

const React = require('react');
const classnames = require('classnames');
const connect = require('react-redux').connect;
const commonHelper = require('../../helper/common-helper.js');
const actions = require('../../action/shop-list/shop-list-wm');

const ShopAll = require('../../component/shop-list/shop-all.jsx');
const Loading = require('../../component/mui/loading.jsx');
const Toast = require('../../component/mui/toast.jsx');

// eslint-disable-next-line
import { getAddressByPoint } from '../../helper/map-TARGET_AREA';
// eslint-disable-next-line
import ChooseAddress from '../../component/shop-list/shop-choose-address-TARGET_AREA';

import FormattedMessage from '@/intl/formatted-message';
import containnerText4 from '../../intl/messages/container/part4';
import { formatMessage } from '../../intl/helper';

const ShopListWMApplication = React.createClass({
  displayName: 'ShopListWMApplication',
  propTypes: {
    // reducer
    allNearShopListWs: React.PropTypes.object,
    allNearShopListZt: React.PropTypes.object,
    allShopListWs: React.PropTypes.array,
    allShopListZt: React.PropTypes.array,
    mineAddressList: React.PropTypes.array,
    load: React.PropTypes.object,
    takeawayInfo: React.PropTypes.object,
    errorMessage: React.PropTypes.string,
    cityListWs: React.PropTypes.array,
    cityListZt: React.PropTypes.array,
    yunChengSchoolFlag: React.PropTypes.bool,
    // action
    getTakeawayInfo: React.PropTypes.func.isRequired,
    getNearShopList: React.PropTypes.func.isRequired,
    getAllShopList: React.PropTypes.func.isRequired,
    getYCSAllShopList: React.PropTypes.func.isRequired,
    clearNearShopListWs: React.PropTypes.func.isRequired,
    clearNearShopListZt: React.PropTypes.func.isRequired,
    clearAllShopListWs: React.PropTypes.func.isRequired,
    clearAllShopListZt: React.PropTypes.func.isRequired,
    getCityList: React.PropTypes.func.isRequired,
    getMineAddressList: React.PropTypes.func.isRequired,
    getCurLocation: React.PropTypes.func.isRequired,
    setLoadMsg: React.PropTypes.func.isRequired,
    clearErrorMsg: React.PropTypes.func,
    setErrorMsg: React.PropTypes.func,
  },
  getInitialState() {
    return {
      tabActive: 'ws',
      showTab: false,
      showNearFromShopAllWS: true,
      showAllFromShopAllWS: false,
      showNearFromShopAllZT: true,
      showAllFromShopAllZT: false,
      lastCityNameWS: null,
      lastCityNameZT: null,
      address: '正在获取当前位置...',
      addressOk: -1,
      curAddressOk: true,
      childView: '',
      point: {},
      chosenPositionSendToPage: {},
      curPosition: {},
      chosenPositionWS: null,
      chosenPositionZT: null,
    };
  },
  // 监听hash变化
  componentWillMount() {
    window.addEventListener('hashchange', this.setChildViewAccordingToHash);
    window.addEventListener('load', this.changeHash);
    this.props.getTakeawayInfo();
    localStorage.removeItem('basicListInfo');
    sessionStorage.removeItem('receiveOrderCustomerInfo');
  },
  componentDidMount() {
    const { getCurLocation, getNearShopList, getCityList } = this.props;
    new Promise((resolve, reject) => {
      getCityList('ws', resolve);
      getCityList('zt', resolve);
    }).then(() => {
      getCurLocation((curPosition, obj = {}) => {
        getNearShopList(curPosition, 'ws', 1, ''); // 启动外送附近门店
        getNearShopList(curPosition, 'zt', 1, ''); // 启动自提附近门店
        this.setState({
          chosenPositionSendToPage: Object.assign({ longitude: '', latitude: '', isGetLoc: false, city: '' }, curPosition),
          curPosition: Object.assign({ longitude: '', latitude: '', isGetLoc: false, city: '' }, curPosition),
          address: obj.address,
          addressOk: obj.addressOk,
          curAddressOk: obj.addressOk,
          point: { longitude: curPosition.longitude, latitude: curPosition.latitude },
        });
      });
    });

    commonHelper.setParamToSession('hdlScence');
  },
  componentWillReceiveProps(newProps) {
    if (newProps.takeawayInfo === this.props.takeawayInfo) {
      return false;
    }
    if (newProps.takeawayInfo.toShop === 1 && newProps.takeawayInfo.toHome === 1) {
      // document.title = '外卖门店列表';
      this.setState({ showTab: true });
    } else if (newProps.takeawayInfo.toShop === 1) {
      // document.title = '自提门店列表';
      this.setState({ tabActive: 'zt' });
    } else if (newProps.takeawayInfo.toHome === 1) {
      // document.title = '外送门店列表';
      this.setState({ tabActive: 'ws' });
    }
    return true;
  },
  setChildViewAccordingToHash() {
    const hash = location.hash;
    const { takeawayInfo = {}, clearNearShopListWs, clearNearShopListZt, clearAllShopListWs, clearAllShopListZt } = this.props;

    if (hash !== '#chooseAddress') {
      if (takeawayInfo.toShop === 1 && takeawayInfo.toHome === 1) {
        document.title = '门店列表';
      } else if (takeawayInfo.toShop === 1) {
        document.title = '门店列表';
      } else if (takeawayInfo.toHome === 1) {
        document.title = '门店列表';
      }
      location.hash = ''; // 如果hash值不等于chooseAddress 那么强制置空
      const { getNearShopList, getAllShopList, setErrorMsg } = this.props;
      const { showNearFromShopAllWS, showAllFromShopAllWS, chosenPositionWS, chosenPositionZT, curPosition } = this.state;
      const chosenAddress = window.chosenAddress;
      if (chosenAddress) {
        if (showNearFromShopAllWS) {
          clearNearShopListWs();
          clearNearShopListZt();
          getNearShopList(chosenAddress, 'ws', 1, '');
          getNearShopList(chosenAddress, 'zt', 1, '');
        }
        if (showAllFromShopAllWS) {
          clearAllShopListWs();
          clearAllShopListZt();
          getAllShopList(chosenPositionWS || {}, curPosition, chosenAddress, 'ws', 1, '');
          if (chosenPositionZT) getAllShopList(chosenPositionZT || {}, curPosition, chosenAddress, 'zt', 1, '');
        }

        this.setState(
          {
            address: chosenAddress.address,
            addressOk: true,
            point: { longitude: chosenAddress.longitude, latitude: chosenAddress.latitude },
          },
          () => {
            getAddressByPoint(this.state.point)
              .then(({ city }) => {
                chosenAddress.city = city;
                this.setState({ chosenPositionSendToPage: chosenAddress });
              })
              .catch(error => {
                setErrorMsg(error.message);
              });
          },
        );
      }
    } else {
      document.title = '配送地址选择';
    }
    this.setState({ childView: hash });
  },
  setShowNaviEntry() {
    const { tabActive, address, addressOk, showNearFromShopAllWS, showAllFromShopAllWS, showNearFromShopAllZT, showAllFromShopAllZT } = this.state;
    const { yunChengSchoolFlag } = this.props;
    let fadeAddress = address;
    if (!addressOk && tabActive === 'zt') {
      fadeAddress = formatMessage(containnerText4.ShopApplicationLocationFailedRefresh);
    } else if (!addressOk && tabActive === 'ws') {
      if (yunChengSchoolFlag) {
        fadeAddress = formatMessage(containnerText4.ShopApplicationLocationFailed);
      } else {
        fadeAddress = formatMessage(containnerText4.ShopApplicationLocationFailedSelect);
      }
    }

    if (tabActive === 'ws') {
      return (
        <ul className="o-list o-border--top o-border--bottom navi-entry">
          <li
            className={classnames('o-list__item c-option', {
              // 'navi-entry-disable': showAllFromShopAllWS,
              '': showNearFromShopAllWS,
            })}
            onTouchTap={!yunChengSchoolFlag && (e => this.chooseAddress(e, showAllFromShopAllWS))}
          >
            <div className="c-option__title-icon">
              <i className="title-icon"></i>
            </div>
            <div className="c-option__body">
              <span
                className={classnames('o-text-ellipsis', {
                  'o-tc--dark': addressOk,
                  'o-tc--tertiary': !addressOk,
                  'o-tc--medium': showAllFromShopAllWS,
                })}
              >
                {fadeAddress}
              </span>
            </div>
            <div className="c-option__ending">{!yunChengSchoolFlag && <i className="o-icon-arrow--right" />}</div>
          </li>
        </ul>
      );
    }
    return (
      <ul className="o-list o-border--top o-border--bottom navi-entry">
        <li
          className={classnames('o-list__item c-option', {
            // 'navi-entry-disable': showAllFromShopAllZT,
            '': showNearFromShopAllZT,
          })}
          onTouchTap={e => this.refreshAddress(e, showAllFromShopAllZT)}
        >
          <div className="c-option__title-icon">
            <i className="title-icon"></i>
          </div>
          <div className="c-option__body">
            <span
              className={classnames('o-text-ellipsis', {
                'o-tc--dark': addressOk,
                'o-tc--tertiary': !addressOk,
                'o-tc--medium': showAllFromShopAllZT,
              })}
            >
              {fadeAddress}
            </span>
          </div>
          <div className="c-option__ending">{<img src={refreshIcon} style={{ width: 20 }} alt="" />}</div>
        </li>
      </ul>
    );
  },
  getShowContentStatus(param) {
    this.setState(param);
  },
  changeHash() {
    if (location.hash) {
      location.hash = '';
    }
  },
  switchTab(type) {
    this.setState({ tabActive: type });
    setTimeout(() => {
      this.refs.shopAll.scrollToTop();
    }, 200);
  },
  chooseAddress(e) {
    e.preventDefault();
    e.stopPropagation();
    location.hash = '#chooseAddress';
  },
  refreshAddress(e, showAllFromShopAllZT) {
    e.preventDefault();
    e.stopPropagation();
    const { getCurLocation, getNearShopList, clearNearShopListWs, clearNearShopListZt, getAllShopList, clearAllShopListWs, clearAllShopListZt } = this.props;
    const { showNearFromShopAllZT, chosenPositionWS, chosenPositionZT } = this.state;

    getCurLocation((curPosition = {}, obj = {}) => {
      if (showNearFromShopAllZT) {
        clearNearShopListWs();
        clearNearShopListZt();
        getNearShopList(curPosition, 'zt', 1, ''); // 启动自提附近门店
        getNearShopList(curPosition, 'ws', 1, ''); // 启动自提附近门店
      }
      if (showAllFromShopAllZT) {
        clearAllShopListWs();
        clearAllShopListZt();
        const chosenAddress = Object.assign({ longitude: '', latitude: '', isGetLoc: false, city: '' }, curPosition);
        if (chosenPositionWS) getAllShopList(chosenPositionWS || {}, curPosition, chosenAddress, 'ws', 1, '');
        getAllShopList(chosenPositionZT || {}, curPosition, chosenAddress, 'zt', 1, '');
      }

      this.setState({
        chosenPositionSendToPage: Object.assign({ longitude: '', latitude: '', isGetLoc: false, city: '' }, curPosition),
        curPosition: Object.assign({ longitude: '', latitude: '', isGetLoc: false }, curPosition),
        address: obj.address,
        addressOk: obj.addressOk,
        curAddressOk: obj.addressOk,
        point: { longitude: curPosition.longitude, latitude: curPosition.latitude },
      });
    });
  },
  render() {
    const {
      tabActive,
      addressOk,
      curAddressOk,
      childView,
      chosenPositionSendToPage,
      curPosition,
      showTab,
      showAllFromShopAllWS,
      showAllFromShopAllZT,
      lastCityNameWS,
      lastCityNameZT,
      chosenPositionWS,
      chosenPositionZT,
    } = this.state;
    // reducers
    const {
      allShopListWs,
      allShopListZt,
      allNearShopListWs,
      allNearShopListZt,
      cityListWs,
      cityListZt,
      mineAddressList,
      load,
      errorMessage,
      takeawayInfo,
      yunChengSchoolFlag,
    } = this.props;
    // action
    const {
      getAllShopList,
      getYCSAllShopList,
      getNearShopList,
      getMineAddressList,
      setLoadMsg,
      clearErrorMsg,
      clearNearShopListWs,
      clearNearShopListZt,
      clearAllShopListWs,
      clearAllShopListZt,
      setErrorMsg,
    } = this.props;
    const showNaviEntry = this.setShowNaviEntry();

    return (
      <div className={classnames('o-bg-grey shop-list-wm', { showTab })} style={{ height: '100%', overflow: 'auto' }}>
        {childView === '#chooseAddress' ? (
          <ChooseAddress
            getMineAddressList={getMineAddressList}
            mineAddressList={mineAddressList}
            setLoadMsg={setLoadMsg}
            curPosition={curPosition}
            curAddressOk={curAddressOk}
            refreshAddress={this.refreshAddress}
            cityList={takeawayInfo.cityList}
          />
        ) : (
          <div>
            {showTab && (
              <div className="o-flex c-tabs">
                <div
                  className={classnames('o-flex__fluid c-tabs__item', {
                    'c-tabs__item--active': tabActive === 'ws',
                  })}
                  onTouchTap={() => {
                    this.switchTab('ws');
                  }}
                >
                  <span>
                    <FormattedMessage {...containnerText4.OrderApplicationoutFor} />
                  </span>
                </div>
                <div
                  className={classnames('o-flex__fluid c-tabs__item', {
                    'c-tabs__item--active': tabActive === 'zt',
                  })}
                  onTouchTap={() => {
                    this.switchTab('zt');
                  }}
                >
                  <span>
                    <FormattedMessage {...containnerText4.OrderApplicationSelfGet} />
                  </span>
                </div>
              </div>
            )}
            {showNaviEntry}
            <ShopAll
              allNearShopListWs={allNearShopListWs}
              allNearShopListZt={allNearShopListZt}
              getAllShopList={getAllShopList}
              getYCSAllShopList={getYCSAllShopList}
              getNearShopList={getNearShopList}
              allShopListWs={allShopListWs}
              allShopListZt={allShopListZt}
              addressOk={addressOk}
              chosenPositionSendToPage={chosenPositionSendToPage}
              curPosition={curPosition}
              tabActive={tabActive}
              showTab={showTab}
              setLoadMsg={setLoadMsg}
              clearNearShopListWs={clearNearShopListWs}
              clearNearShopListZt={clearNearShopListZt}
              clearAllShopListWs={clearAllShopListWs}
              clearAllShopListZt={clearAllShopListZt}
              cityListWs={cityListWs}
              cityListZt={cityListZt}
              yunChengSchoolFlag={yunChengSchoolFlag}
              getShowContentStatus={this.getShowContentStatus}
              showAllFromShopAllWS={showAllFromShopAllWS}
              showAllFromShopAllZT={showAllFromShopAllZT}
              chosenPositionWS={chosenPositionWS}
              chosenPositionZT={chosenPositionZT}
              lastCityNameWS={lastCityNameWS}
              lastCityNameZT={lastCityNameZT}
              loading={load.status}
              setErrorMsg={setErrorMsg}
              ref="shopAll"
            />
          </div>
        )}
        {load.status ? <Loading word={load.word} /> : false}
        {errorMessage ? <Toast clearErrorMsg={clearErrorMsg} errorMessage={errorMessage} /> : false}
      </div>
    );
  },
});
module.exports = connect(
  state => state,
  actions,
)(ShopListWMApplication);



// WEBPACK FOOTER //
// ./src/container/shop-list-wm/application.jsx